<script>
  import { Spinner } from "sveltestrap";
</script>

<style>
  .spinner-container {
    margin: 0 auto;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .spinner-container h5 {
    margin: 10px;
  }
</style>

<div class="spinner-container">
  <!-- <h5>Loading..</h5>
  <br /> -->
  <Spinner size="lg" style="width: 100px; height: 100px;" />
</div>
